/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = morningstar;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = _;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = angular;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _) {
    'use strict';

    reportBuilder.$inject = ["reportBuilderService"];
    angular.module('ecReportBuilder', ['mstarCore', 'ecButton', 'ecChosen', 'ecContainer', 'ecInput', 'ecPortfolioData']).directive('ecReportBuilder', reportBuilder);

    function reportBuilder(reportBuilderService) {
        return {
            restrict: 'E',
            require: 'mstarComponentId',
            scope: {},
            template: morningstar.asterix.ng.util.createTemplateFunction('_templates.main'),
            link: linkFn
        };

        function linkFn(scope, elem, attr, mstarComponent) {
            // binds settings, labels, formatter and templates to scope properties
            mstarComponent.bindConfig(scope);

            // compiles the main template
            mstarComponent.compileTemplate(scope, '_templates.main');

            // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
            mstarComponent.bindParameters(scope);

            // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
            mstarComponent.bindModelData(scope, { editable: true });
            // ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.

            var languageId = scope.settings.get('languageId');
            var dateFormatter = morningstar.asterix.formatting.getFormatter(languageId).date;
            var todayDate = dateFormatter(new Date(), scope.settings.get('coverPageDateFormat'));
            scope.isLoading = false;
            scope.model.reportInfo = morningstar.asterix.extend(true, {}, {
                reportName: null,
                reportContents: [],
                reportCoverPage: {
                    preparedBy: {},
                    preparedFor: {},
                    reportDate: todayDate,
                    title: null
                },
                reportNotesPage: {
                    notes: {}
                },
                reportPortfolios: []
            }, scope.model.reportInfo);

            scope.availableReportContents = [];
            scope.coverPagePreparedBy = getCoverPageFieldGroup('coverPagePreparedByFieldDefinition');
            scope.coverPagePreparedFor = getCoverPageFieldGroup('coverPagePreparedForFieldDefinition');
            scope.notes = getCoverPageFieldGroup('notesFieldDefinition');

            setCoverPagePreparedFieldValue(scope.model.reportInfo.reportCoverPage.preparedBy, scope.coverPagePreparedBy);
            setCoverPagePreparedFieldValue(scope.model.reportInfo.reportCoverPage.preparedFor, scope.coverPagePreparedFor);
            setCoverPagePreparedFieldValue(scope.model.reportInfo.reportNotesPage.notes, scope.notes);

            // listen to changes to contents listItem and update scope
            mstarComponent.addUnregisterCallback(scope.instance.findRelative('reportContents').on('modelPropertyChanged:listItems', function (listItems) {
                scope.availableReportContents = listItems;
            }));

            mstarComponent.addUnregisterCallback(mstarComponent.getComponentInstance().on('modelChanged', function (model) {
                var reportContents = morningstar.asterix.util.parse('reportInfo.reportContents')(model) || [];
                scope.instance.findRelative('reportGenerateButton').setParameter('disabled', reportContents.length === 0);
                //Update selectedContents model so we can bind sections visibility to them more easily
                //selectedContens will hold an object that is the list of selected contents with "true" as their value (ie. { coverPage:true, ...})
                scope.model.selectedContents = {};
                _.each(reportContents, function (value, key) {
                    scope.model.selectedContents[value] = true;
                });

                // Add class to "Select all" for partially selected options
                if (reportContents.length > 0 && reportContents.length < scope.availableReportContents.length) {
                    scope.partialSelect = true;
                } else {
                    scope.partialSelect = false;
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.findRelative('reportGenerateButton').on('click', function (event) {
                reportBuilderService.generateReport(scope);
            }));

            // Checks if all checkboxes are selected or not
            // @return {Boolean}
            scope.allCheckboxesSelected = function () {
                return scope.model.reportInfo.reportContents && scope.model.reportInfo.reportContents.length === scope.availableReportContents.length;
            };

            // Handle click on "select all" checkbox
            // This basically just calls toggleAllOptions without bubbling down
            // and leaves toggleAllOptions clean for testing
            // @param {Event} $event The event that triggered the function
            scope.handleSelectAllClick = function ($event) {
                // avoid event bubbling down
                // will be called more than once otherwise (we do not want that)
                $event.preventDefault();
                $event.stopPropagation();

                scope.toggleAllOptions();
            };

            // Toggle all checkboxes on or off, depending on current state
            scope.toggleAllOptions = function () {
                // update scope with all or none of the options
                if (scope.allCheckboxesSelected()) {
                    scope.model.reportInfo.reportContents = [];
                } else {
                    // get all the available contents keys (in string format)
                    var contentKeys = _.map(_.pluck(scope.availableReportContents, 'key'), function (key) {
                        return key.toString();
                    });
                    scope.model.reportInfo.reportContents = contentKeys;
                }
            };

            function getCoverPageFieldGroup(key) {
                var retArray = [];
                _.each(scope.settings.get(key), function (item) {
                    retArray.push({
                        labelKey: item.labelKey,
                        inputType: morningstar.asterix.util.string.firstUpperCase(item.inputType),
                        className: morningstar.asterix.util.string.dashCase(item.labelKey)
                    });
                });
                return retArray;
            }

            function setCoverPagePreparedFieldValue(reportPreparedField, preparedFieldDefinition) {
                _.each(preparedFieldDefinition, function (item) {
                    reportPreparedField[item.labelKey] = reportPreparedField[item.labelKey] || null;
                });
            }
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, _) {
    'use strict';

    var helper = {
        clickedReportBuilderButtonEvent: clickedReportBuilderButtonEvent,
        clickedCancelButtonEvent: clickedCancelButtonEvent,
        changedPdfStatusParameter: changedPdfStatusParameter
    };

    angular.module('ecReportBuilder').factory('reportBuilderHelperService', function () {
        return helper;
    });

    function clickedReportBuilderButtonEvent(context, instanceType) {
        if (context.settings.get('directlyGenerateReport')) {
            context.instance.findRelative('reportBuilder.reportGenerateButton').trigger('click');
        } else {
            checkHoldingsForCorrelationMatrix(context, instanceType);
            context.model.sections.showReportBuilder = !context.model.sections.showReportBuilder;
            context.model.sections.showToolBar = !context.model.sections.showReportBuilder;
            context.model.sections.showEditPortfolio = !context.model.sections.showReportBuilder;
        }
    }

    function checkHoldingsForCorrelationMatrix(context, instanceType) {
        //when portfolio holding length < 2, to disable correlation matrix report
        var reportContentsInstance = context.instance.findRelative('reportBuilder.reportContents'),
            reportContentsItems = reportContentsInstance.model.listItems;
        var correlationMatrix = _.find(reportContentsItems, function (item) {
            return item.key === 'correlationMatrix';
        });
        if (correlationMatrix) {
            if (instanceType === 'xray') {
                correlationMatrix.disabled = context.parameters.portfolio.holdings.length < 2;
            } else if (instanceType === 'portfolioCompare') {
                correlationMatrix.disabled = context.parameters.portfolio.current.holdings.length < 2 || context.parameters.portfolio.proposed.holdings.length < 2;
            }
            reportContentsInstance.setModelProperty('listItems', reportContentsItems);

            //when correlation matrix report is checked but portfolio holding length change to < 2, uncheck it.
            var reportBuilderInstance = context.instance.findRelative('reportBuilder'),
                reportBuilderModel = reportBuilderInstance.model,
                reportContents = morningstar.asterix.util.parse('reportInfo.reportContents')(reportBuilderModel) || [];
            if (correlationMatrix.disabled) {
                reportBuilderInstance.setModelProperty('reportInfo.reportContents', _.without(reportContents, 'correlationMatrix'));
            }
        }
    }

    function clickedCancelButtonEvent(context) {
        context.model.sections.showToolBar = true;
        context.model.sections.showReportBuilder = false;
        context.model.sections.showEditPortfolio = true;
    }

    function changedPdfStatusParameter(context, pdfStatus) {
        if (context.model.sections.showReportBuilder && !pdfStatus) {
            context.model.sections.showReportBuilder = false;
            context.model.sections.showToolBar = true;
            context.model.sections.showEditPortfolio = true;
        }
    }
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/* jshint browser: true */
!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2), __webpack_require__(0), __webpack_require__(1), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (angular, morningstar, _, dataPointMapping) {
    'use strict';

    angular.module('ecReportBuilder').factory('reportBuilderService', ['mstarAjax', '$window', 'portfolioDataTransformHelperService', function (mstarAjax, $window, portfolioDataTransformHelperService) {
        var COVER_PAGE = 'coverPage';

        function generateReport(scope) {
            var reportDataSource = scope.settings.get('reportDataSource') || {};
            var reportDataSettings = {
                requestMethod: reportDataSource.requestMethod,
                url: reportDataSource.url,
                reportCoverPage: morningstar.asterix.util.parse('model.reportInfo.reportCoverPage')(scope) || {},
                reportContents: morningstar.asterix.util.parse('model.reportInfo.reportContents')(scope) || [],
                reportName: morningstar.asterix.util.parse('model.reportInfo.reportPortfolios[0].reportName')(scope),
                reportSettings: morningstar.asterix.util.merge({}, scope.settings.get('reportSettings'), morningstar.asterix.util.parse('model.reportInfo.reportSettings')(scope)),
                portfolios: morningstar.asterix.util.parse('model.reportInfo.reportPortfolios')(scope) || [],
                languageId: scope.settings.get('languageId')
            };

            if (isValidReportDataSettings(reportDataSettings)) {
                if (reportDataSource.type === 'USAPI') {
                    generateUsxRayReport(scope, reportDataSettings);
                } else if (reportDataSource.type === 'UKAPI') {
                    generateUkxRayReport(scope, reportDataSettings);
                }
            }
        }

        // For US x-ray report
        function generateUsxRayReport(scope, reportDataSettings) {
            scope.parameters.isLoading = true;
            var urlParameters = portfolioDataTransformHelperService.generatePAAPIUrlParameters(scope);
            reportDataSettings.portfolios[0].Name = reportDataSettings.reportName;

            if (urlParameters.apiTokenType && urlParameters.apiTokenValue) {
                reportDataSettings.url = reportDataSettings.url + '&' + urlParameters.apiTokenType + '=' + urlParameters.apiTokenValue;
            }
            openPdf(scope, {
                requestMethod: reportDataSettings.requestMethod,
                url: morningstar.asterix.util.url.parameterize(reportDataSettings.url, {
                    baseUrl: urlParameters.baseUrl,
                    langcult: reportDataSettings.languageId
                }),
                requestData: morningstar.asterix.util.merge({}, reportDataSettings.reportSettings, {
                    RequestSettings: generateUsRequestSettings(scope, reportDataSettings),
                    portfolios: reportDataSettings.portfolios
                })
            });
        }

        function generateUsRequestSettings(scope, reportDataSettings) {
            var coverPageIndex = _.indexOf(reportDataSettings.reportContents, COVER_PAGE);
            var reportPages = morningstar.asterix.extend(true, [], reportDataSettings.reportContents);
            var requestSettings = {
                ReportSettings: {}
            };
            var preparedByDataPointDefinition = morningstar.asterix.util.parse('xray.us.coverPagePreparedByFieldDefinition')(dataPointMapping);
            var preparedForDataPointDefinition = morningstar.asterix.util.parse('xray.us.coverPagePreparedForFieldDefinition')(dataPointMapping);
            if (coverPageIndex > -1) {
                reportPages.splice(coverPageIndex, 1);
                requestSettings.ReportSettings.ReportPages = reportPages;
                requestSettings.ReportSettings.CoverPage = {
                    ReportTitle: reportDataSettings.reportCoverPage.title,
                    PreparedFor: generateCoverPagePreparedInfo(reportDataSettings.reportCoverPage.preparedFor, scope.settings.get('coverPagePreparedForFieldDefinition'), preparedForDataPointDefinition),
                    PreparedBy: generateCoverPagePreparedInfo(reportDataSettings.reportCoverPage.preparedBy, scope.settings.get('coverPagePreparedByFieldDefinition'), preparedByDataPointDefinition)
                };
            } else {
                requestSettings.ReportSettings.ReportPages = reportPages;
            }
            return requestSettings;
        }

        // For Uk xRay Report
        function generateUkxRayReport(scope, reportDataSettings) {
            scope.parameters.isLoading = true;

            reportDataSettings.portfolios[0].name = reportDataSettings.reportName;

            openPdf(scope, {
                requestMethod: reportDataSettings.requestMethod,
                url: morningstar.asterix.util.url.parameterize(reportDataSettings.url, {
                    baseUrl: scope.settings.get('baseUrlPdfServiceEU')
                }),

                requestData: {
                    settings: {
                        languageId: reportDataSettings.languageId,
                        currencyId: reportDataSettings.portfolios[0].currencyId || scope.settings.get('currencyId')
                    },
                    components: generateUkComponents(scope, reportDataSettings)
                }
            });
        }

        function generateUkComponents(scope, reportDataSettings) {
            var components = {},
                reportOrder = [],
                reportType;

            morningstar.asterix.util.each(reportDataSettings.reportContents, function (item, index) {
                reportOrder.push({
                    id: item
                });
            });

            if (reportDataSettings.reportSettings.xrayReport) {
                reportType = 'xrayReport';
            } else if (reportDataSettings.reportSettings.portfolioComparisonReport) {
                reportType = 'portfolioComparisonReport';
            }

            components[reportType] = {
                settings: {
                    urlKey: scope.settings.get('urlKey'),
                    reportOrder: reportOrder,
                    _parameters: generateUkParameters(scope, reportDataSettings, reportType),
                    pdfServer: scope.settings.get('pdfServer')
                }
            };
            return morningstar.asterix.util.merge({}, reportDataSettings.reportSettings, components);
        }

        function generateUkParameters(scope, reportDataSettings, reportType) {
            var parameters = {};
            if (reportType === 'xrayReport') {
                parameters.portfolio = reportDataSettings.portfolios[0];
            } else if (reportType === 'portfolioComparisonReport') {
                parameters.currentPortfolio = reportDataSettings.portfolios[0];
                parameters.proposedPortfolio = reportDataSettings.portfolios[1];
            }
            var preparedByDataPointDefinition = morningstar.asterix.util.parse('xray.uk.coverPagePreparedByFieldDefinition')(dataPointMapping);
            var preparedForDataPointDefinition = morningstar.asterix.util.parse('xray.uk.coverPagePreparedForFieldDefinition')(dataPointMapping);
            var coverPageIndex = _.indexOf(reportDataSettings.reportContents, COVER_PAGE);
            if (coverPageIndex > -1) {
                parameters.coverInfo = {
                    title: reportDataSettings.reportCoverPage.title,
                    reportDate: scope.format.date(new Date(), 'yyyy-mm-dd'),
                    preparedBy: generateCoverPagePreparedInfo(reportDataSettings.reportCoverPage.preparedBy, scope.settings.get('coverPagePreparedByFieldDefinition'), preparedByDataPointDefinition),
                    preparedFor: generateCoverPagePreparedInfo(reportDataSettings.reportCoverPage.preparedFor, scope.settings.get('coverPagePreparedForFieldDefinition'), preparedForDataPointDefinition)
                };
            }

            return parameters;
        }

        //commom function
        function generateCoverPagePreparedInfo(prepared, fieldDefinition, dataPointDefinition) {
            var obj = {};
            if (prepared && fieldDefinition) {
                var advisors = {};
                _.each(fieldDefinition, function (item) {
                    if (prepared[item.labelKey]) {
                        if (morningstar.asterix.util.parse('advisors.' + item.labelKey)(dataPointDefinition)) {
                            advisors[dataPointDefinition.advisors[item.labelKey]] = prepared[item.labelKey];
                        } else {
                            obj[dataPointDefinition[item.labelKey]] = prepared[item.labelKey];
                        }
                    }
                });
                if (!_.isEmpty(advisors)) {
                    obj.Advisors = [];
                    obj.Advisors.push(advisors);
                }
            }
            return obj;
        }

        function isValidReportDataSettings(reportDataSettings) {
            if (!reportDataSettings.reportSettings) {
                morningstar.asterix.util.log.debug('Missing report settings in report-builder');
                return false;
            }
            if (reportDataSettings.portfolios.length === 0) {
                morningstar.asterix.util.log.debug('Missing portfolios in report-builder');
                return false;
            }
            return true;
        }

        function openPdf(scope, apiSettings) {
            var headers = {
                accept: 'application/pdf',
                authorization: morningstar.asterix.context.getToken('apiGatewayToken')
            };
            mstarAjax.api({
                method: apiSettings.requestMethod,
                url: apiSettings.url,
                headers: headers,
                responseType: 'arraybuffer'
            }, apiSettings.requestData).promise.then(function (response) {
                scope.parameters.isLoading = false;
                var blob = new Blob([response], {
                    type: 'application/pdf'
                });
                if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
                    $window.navigator.msSaveOrOpenBlob(blob); // for IE
                } else {
                    var fileURL = URL.createObjectURL(blob);
                    $window.open(fileURL);
                }
            });
        }

        return {
            generateReport: generateReport
        };
    }]);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = {
	"ecReportBuilder": {
		"blueprints": {
			"plannerReportBuilder": {
				"blueprint": "standardPlanner",
				"components": {
					"reportContents": {
						"labels": {
							"coverPage": {
								"da-DK": "Forside",
								"en": "Cover Page",
								"fr": "Page de garde",
								"fr-CA": "Page de couverture",
								"it": "Copertina",
								"sv": "Framsida",
								"zh-CN": "封面",
								"zh-HK": "封面"
							},
							"goalAnalysis": {
								"da-DK": "Analyse af Mål",
								"en": "Goal Analysis",
								"fr": "Analyses de l'objectif",
								"fr-CA": "Analyse de l'objectif",
								"it": "Analisi degli obiettivi",
								"sv": "Målanalys",
								"zh-CN": "目标分析",
								"zh-HK": "目標分析"
							},
							"kiid": {
								"da-DK": "CI",
								"en": "KIID",
								"fr": "DICI",
								"it": "KIID",
								"sv": "KIID",
								"zh-CN": "KIID",
								"zh-HK": "KIID"
							},
							"proposedPortfolio": {
								"da-DK": "Foreslået Portefølje",
								"en": "Proposed Portfolio",
								"fr": "Portefeuille proposé",
								"it": "Portafoglio proposto",
								"sv": "Föreslagen portfölj",
								"zh-CN": "建议投资组合",
								"zh-HK": "建議投資組合"
							},
							"questionnaire": {
								"da-DK": "Spørgeskema",
								"en": "Questionnaire",
								"fr": "Questionnaire",
								"it": "Questionario",
								"sv": "Frågeformulär",
								"zh-CN": "调查问卷",
								"zh-HK": "調查問卷"
							}
						},
						"settings": {
							"_model": {
								"listItems": [
									{
										"key": "coverPage",
										"value": "coverPage"
									},
									{
										"key": "goal",
										"value": "goalAnalysis"
									},
									{
										"key": "rtqReport",
										"value": "questionnaire"
									},
									{
										"key": "riskProfile",
										"value": "riskProfile"
									},
									{
										"key": "proposedXrayReport",
										"value": "proposedPortfolio"
									},
									{
										"key": "kiidDocuments",
										"value": "kiid"
									}
								]
							},
							"controlType": "checkbox"
						},
						"type": "ecChosen"
					}
				},
				"settings": {
					"_model": {
						"reportInfo": {
							"dataSourceType": "selector",
							"selector": "{{_ model(_).reportInfo _}}"
						}
					}
				},
				"type": "ecReportBuilder"
			},
			"standardPlanner": {
				"components": {
					"containerReportBuilder": {
						"settings": {
							"breakpoints": {
								"large": "medium",
								"medium": {
									"groups": {
										"left": {
											"cols": 4,
											"defaultSection": {
												"cols": 12
											},
											"order": 0,
											"sections": [
												"reportContents"
											]
										},
										"right": {
											"cols": 8,
											"defaultSection": {
												"cols": 12
											},
											"order": 1,
											"sections": [
												"reportCoverPageTitle",
												{
													"cols": 6,
													"sectionId": "reportCoverPagePreparedFor"
												},
												{
													"cols": 6,
													"sectionId": "reportCoverPagePreparedBy"
												},
												"reportNotes"
											]
										}
									}
								},
								"small": {
									"groups": {
										"all": {
											"defaultSection": {
												"cols": 12
											},
											"sections": [
												"reportCoverPageTitle",
												"reportContents",
												"reportCoverPagePreparedFor",
												"reportCoverPagePreparedBy",
												"reportNotes"
											]
										}
									}
								},
								"xlarge": "large"
							},
							"sections": {
								"reportCoverPagePreparedBy": {
									"show": "{{_ model(_).coverPageUserInput.show _}}"
								},
								"reportCoverPagePreparedFor": {
									"show": "{{_ model(_).coverPageUserInput.show _}}"
								},
								"reportNotes": {
									"show": "{{_ model(_).selectedContents.advisorNotes _}}"
								}
							}
						},
						"type": "ecContainer"
					},
					"reportContents": {
						"settings": {
							"_model": {
								"listItems": [
									{
										"key": "coverPage",
										"value": "coverPage"
									},
									{
										"key": "rtqReport",
										"value": "questionnaire"
									},
									{
										"key": "riskProfile",
										"value": "riskProfile"
									},
									{
										"key": "currentXrayReport",
										"value": "currentPortfolio"
									},
									{
										"key": "proposedXrayReport",
										"value": "proposedPortfolio"
									},
									{
										"key": "portfolioComparisonReport",
										"value": "portfolioComparison"
									},
									{
										"key": "assetAllocator",
										"value": "goalAnalysis"
									},
									{
										"key": "suitability",
										"value": "suitabilitySummary"
									},
									{
										"key": "costComparison",
										"value": "costAnalysis"
									},
									{
										"key": "advisorNotes",
										"value": "advisorNotes"
									},
									{
										"key": "kiidDocuments",
										"value": "keyInvestorInformationDocuments"
									},
									{
										"key": "fundProfiles",
										"micro": "reportWarning",
										"value": "fundProfiles"
									},
									{
										"key": "signOff",
										"value": "signOff"
									}
								]
							},
							"controlType": "checkbox",
							"microValueField": "micro"
						},
						"type": "ecChosen"
					}
				},
				"labels": {
					"advisorNotes": {
						"da-DK": "Rådgivers Noter",
						"en": "Advisor Notes",
						"fr": "Notes du conseiller",
						"it": "Note del consulente",
						"sv": "Rågivarens anteckningar",
						"zh-CN": "顾问笔记",
						"zh-HK": "顧問筆記"
					},
					"costAnalysis": {
						"da-DK": "Omkostningsanalyse",
						"en": "Cost Analysis",
						"fr": "Analyse des coûts",
						"fr-CA": "",
						"it": "Analisi dei costi",
						"sv": "Kostnadsanalys",
						"zh-CN": "成本分析",
						"zh-HK": "成本分析"
					},
					"coverPage": {
						"da-DK": "Forside",
						"en": "Cover Page",
						"fr": "Page de garde",
						"fr-CA": "Page de couverture",
						"it": "Copertina",
						"sv": "Framsida",
						"zh-CN": "封面",
						"zh-HK": "封面"
					},
					"currentPortfolio": {
						"da-DK": "Nuværende Portefølje",
						"en": "Current Portfolio",
						"fr-FR": "Portefeuille actuel",
						"it": "Portafoglio corrente",
						"sv": "Nuvarande portfölj"
					},
					"fundProfiles": {
						"da-DK": "Faktaark",
						"en": "Fund Profile",
						"fr": "Profil du fonds",
						"fr-CA": "Profil du fonds",
						"it": "Profilo del fondo",
						"sv": "Fund report PDF",
						"zh-CN": "基金简介",
						"zh-HK": "基金簡介"
					},
					"goalAnalysis": {
						"da-DK": "Analyse af Mål",
						"en": "Goal Analysis",
						"fr": "Analyses de l'objectif",
						"fr-CA": "Analyse de l'objectif",
						"it": "Analisi degli obiettivi",
						"sv": "Målanalys",
						"zh-CN": "目标分析",
						"zh-HK": "目標分析"
					},
					"keyInvestorInformationDocuments": {
						"da-DK": "CI",
						"en": "KIID",
						"fr": "DICI",
						"it": "KIID",
						"sv": "KIID",
						"zh-CN": "KIID",
						"zh-HK": "KIID"
					},
					"portfolioComparison": {
						"da-DK": "Porteføljesammenligning",
						"en": "Portfolio Comparison",
						"fr": "Comparaison de portefeuilles",
						"it": "Confronto portafoglio",
						"sv": "Portföljjämförelse"
					},
					"preparedByAddressLine1": {
						"da-DK": "Adresselinie 1",
						"en": "Address Line 1",
						"fr": "Adresse Ligne 1",
						"fr-CA": "Ligne 1 de l'adresse",
						"it": "Indirizzo riga 1",
						"sv": "Adress rad 1",
						"zh-CN": "地址行1",
						"zh-HK": "地址行1"
					},
					"preparedByAddressLine2": {
						"da-DK": "Adresselinje 2",
						"en": "Address Line 2",
						"fr": "Adresse Ligne 2",
						"fr-CA": "Ligne 2 de l'adresse",
						"it": "Indirizzo riga 2",
						"sv": "Adress rad 2",
						"zh-CN": "地址行2",
						"zh-HK": "地址行2"
					},
					"preparedByAdvisorEmail1": {
						"da-DK": "Rådgiver E-mail 1",
						"en": "Advisor Email 1",
						"fr": "Email du conseiller 1",
						"fr-CA": "Adresse courriel du conseiller 1",
						"it": "E-mail consulente 1",
						"sv": "Epost rådgivare 1",
						"zh-CN": "顾问电子邮件1",
						"zh-HK": "顧問電子郵件1"
					},
					"preparedByAdvisorEmail2": {
						"da-DK": "Rådgiver E-mail 2",
						"en": "Advisor Email 2",
						"fr": "Email du conseiller 2",
						"fr-CA": "Adresse courriel du conseiller 2",
						"it": "E-mail consulente 2",
						"sv": "Epost rådgivare 2",
						"zh-CN": "顾问电子邮件2",
						"zh-HK": "顧問電子郵件2"
					},
					"preparedByAdvisorName1": {
						"da-DK": "Rådgivernavn 1",
						"en": "Advisor Name 1",
						"fr": "Nom du conseiller 1",
						"it": "Nome consulente 1",
						"sv": "Namn på rådgivare 1",
						"zh-CN": "顾问名称1",
						"zh-HK": "顧問名稱1"
					},
					"preparedByAdvisorName2": {
						"da-DK": "Rådgivernavn 2",
						"en": "Advisor Name 2",
						"fr": "Nom du conseiller 2",
						"it": "Nome consulente 2",
						"sv": "Namn på rådgivare 2",
						"zh-CN": "顾问名称2",
						"zh-HK": "顧問名稱2"
					},
					"preparedByAdvisorTitle1": {
						"da-DK": "Rådgiver Titel 1",
						"en": "Advisor Title 1",
						"fr": "Titre du conseiller 1",
						"it": "Titolo consulente 1",
						"sv": "Titel för rådgivare 1",
						"zh-CN": "顾问职务1",
						"zh-HK": "顧問職務1"
					},
					"preparedByAdvisorTitle2": {
						"da-DK": "Rådgiver Titel 2",
						"en": "Advisor Title 2",
						"fr": "Titre du conseiller 2",
						"it": "Titolo consulente 2",
						"sv": "Titel för rådgivare 2",
						"zh-CN": "顾问职务2",
						"zh-HK": "顧問職務2"
					},
					"preparedByFirmName": {
						"da-DK": "Firmanavn",
						"en": "Firm Name",
						"fr": "Société",
						"fr-CA": "Nom de la firme",
						"it": "Nome società",
						"sv": "Företagets namn",
						"zh-CN": "公司名称",
						"zh-HK": "公司名稱"
					},
					"preparedByPhone": {
						"da-DK": "Telefonnummer ",
						"en": "Phone Number",
						"fr": "Téléphone",
						"it": "Numero di telefono",
						"sv": "Telefonnummer",
						"zh-CN": "电话号码",
						"zh-HK": "電話號碼"
					},
					"preparedByWebsite": {
						"da-DK": "Hjemmeside",
						"en": "Website",
						"fr": "Site Internet",
						"fr-CA": "Site Web",
						"it": "Sito web",
						"sv": "Webbsida",
						"zh-CN": "网站",
						"zh-HK": "網站"
					},
					"preparedForAddressLine1": {
						"da-DK": "Adresselinie 1",
						"en": "Address Line 1",
						"fr": "Adresse Ligne 1",
						"fr-CA": "Ligne 1 de l'adresse",
						"it": "Indirizzo riga 1",
						"sv": "Adress rad 1",
						"zh-CN": "地址行1",
						"zh-HK": "地址行1"
					},
					"preparedForAddressLine2": {
						"da-DK": "Adresselinje 2",
						"en": "Address Line 2",
						"fr": "Adresse Ligne 2",
						"fr-CA": "Ligne 2 de l'adresse",
						"it": "Indirizzo riga 2",
						"sv": "Adress rad 2",
						"zh-CN": "地址行2",
						"zh-HK": "地址行2"
					},
					"preparedForCity": {
						"da-DK": "By",
						"en": "City",
						"fr": "Ville",
						"it": "Città",
						"sv": "Stad",
						"zh-CN": "城市",
						"zh-HK": "城市"
					},
					"preparedForEmail": {
						"da-DK": "E-mail Adresse",
						"en": "Email Address",
						"fr": "E-Mail",
						"fr-CA": "Adresse courriel",
						"it": "Indirizzo e-mail",
						"sv": "Epostadress",
						"zh-CN": "电邮地址",
						"zh-HK": "電郵地址"
					},
					"preparedForName": {
						"da-DK": "Navn",
						"en": "Name",
						"fr": "Nom",
						"it": "Nome",
						"sv": "Namn",
						"zh-CN": "名称",
						"zh-HK": "名稱"
					},
					"preparedForPhone": {
						"da-DK": "Telefonnummer ",
						"en": "Phone Number",
						"fr": "Téléphone",
						"it": "Numero di telefono",
						"sv": "Telefonnummer",
						"zh-CN": "电话号码",
						"zh-HK": "電話號碼"
					},
					"proposedPortfolio": {
						"da-DK": "Foreslået Portefølje",
						"en": "Proposed Portfolio",
						"fr": "Portefeuille Proposé",
						"it": "Portafoglio proposto",
						"sv": "Föreslagen portfölj",
						"zh-CN": "建议投资组合",
						"zh-HK": "建議投資組合"
					},
					"questionnaire": {
						"da-DK": "Spørgeskema",
						"en": "Questionnaire",
						"fr": "Questionnaire",
						"it": "Questionario",
						"sv": "Frågeformulär",
						"zh-CN": "调查问卷",
						"zh-HK": "調查問卷"
					},
					"reportCoverPage": {
						"da-DK": "Rapportens Overskrift",
						"en": "Report Title",
						"fr": "Titre du rapport",
						"it": "Titolo Report",
						"sv": "Titel på rapporten",
						"zh-CN": "报告标题",
						"zh-HK": "報告標題"
					},
					"reportWarning": {
						"en": "Including this might take at least 1 minute for report processing.",
						"fr": "Inclure ceci peut augmenter le temps de génération de plus d'une minute.",
						"it": "In totale, l'elaborazione del report potrebbe durare almeno 1 minuto",
						"sv": "Att skapa rapporten tar minst 1 minut om dessa inkluderas."
					},
					"suitabilitySummary": {
						"da-DK": "Oversigt Over Egnethed",
						"en": "Suitability Summary",
						"fr": "Résumé de soutenabilité",
						"it": "Sintesi dell'idoneità",
						"sv": "Översikt över lämplighet"
					}
				},
				"settings": {
					"coverPagePreparedByFieldDefinition": [
						{
							"inputType": "text",
							"labelKey": "preparedByAdvisorTitle1"
						},
						{
							"inputType": "text",
							"labelKey": "preparedByAdvisorName1"
						},
						{
							"inputType": "email",
							"labelKey": "preparedByAdvisorEmail1"
						},
						{
							"inputType": "text",
							"labelKey": "preparedByAdvisorTitle2"
						},
						{
							"inputType": "text",
							"labelKey": "preparedByAdvisorName2"
						},
						{
							"inputType": "email",
							"labelKey": "preparedByAdvisorEmail2"
						},
						{
							"inputType": "text",
							"labelKey": "preparedByFirmName"
						},
						{
							"inputType": "text",
							"labelKey": "preparedByAddressLine1"
						},
						{
							"inputType": "text",
							"labelKey": "preparedByAddressLine2"
						},
						{
							"inputType": "url",
							"labelKey": "preparedByWebsite"
						},
						{
							"inputType": "text",
							"labelKey": "preparedByPhone"
						}
					],
					"coverPagePreparedForFieldDefinition": [
						{
							"inputType": "text",
							"labelKey": "preparedForName"
						},
						{
							"inputType": "text",
							"labelKey": "preparedForAddressLine1"
						},
						{
							"inputType": "text",
							"labelKey": "preparedForAddressLine2"
						},
						{
							"inputType": "text",
							"labelKey": "preparedForPhone"
						},
						{
							"inputType": "email",
							"labelKey": "preparedForEmail"
						}
					],
					"notesFieldDefinition": [
						{
							"inputType": "text",
							"labelKey": "advisorNotes"
						}
					]
				},
				"type": "ecReportBuilder"
			},
			"standardUK": {
				"components": {
					"containerReportBuilder": {
						"settings": {
							"breakpoints": {
								"large": "medium",
								"medium": "small",
								"small": {
									"groups": {
										"all": {
											"cols": 12,
											"defaultSection": {
												"cols": 2
											},
											"order": 0,
											"sections": [
												{
													"cols": 8,
													"sectionId": "reportName"
												},
												"reportGenerateButton",
												"reportCancelButton"
											]
										},
										"coverPage": {
											"cols": 12,
											"defaultSection": {
												"cols": 12
											},
											"order": 2,
											"sections": [
												"reportCoverPageTitle",
												"reportCoverPagePreparedFor",
												"reportCoverPagePreparedBy"
											],
											"show": "{{_ model(_).selectedContents.coverPage _}}"
										},
										"reportPages": {
											"cols": 12,
											"defaultSection": {
												"cols": 12
											},
											"order": 1,
											"sections": [
												"reportContents"
											]
										}
									}
								},
								"xlarge": "large"
							}
						},
						"type": "ecContainer"
					},
					"reportContents": {
						"settings": {
							"_model": {
								"listItems": [
									{
										"key": "coverPage",
										"value": "coverPage"
									},
									{
										"key": "xrayReportComponent",
										"value": "portfolioXRay"
									}
								]
							},
							"controlType": "checkbox"
						},
						"type": "ecChosen"
					}
				},
				"settings": {
					"__env": {
						"dev": {
							"pdfServer": "qa"
						},
						"production": {
							"pdfServer": "live"
						},
						"qa": {
							"pdfServer": "qa"
						},
						"stage": {
							"pdfServer": "qa"
						},
						"uat": {
							"pdfServer": "qa"
						}
					},
					"coverPagePreparedByFieldDefinition": [
						{
							"inputType": "text",
							"labelKey": "title"
						},
						{
							"inputType": "text",
							"labelKey": "company"
						},
						{
							"inputType": "text",
							"labelKey": "name"
						},
						{
							"inputType": "text",
							"labelKey": "phone"
						},
						{
							"inputType": "email",
							"labelKey": "email"
						},
						{
							"inputType": "url",
							"labelKey": "website"
						}
					],
					"coverPagePreparedForFieldDefinition": [
						{
							"inputType": "text",
							"labelKey": "clientName"
						},
						{
							"inputType": "text",
							"labelKey": "clientPhone"
						},
						{
							"inputType": "text",
							"labelKey": "clientAddress"
						},
						{
							"inputType": "email",
							"labelKey": "clientEmail"
						}
					],
					"reportDataSource": {
						"requestMethod": "post",
						"type": "UKAPI",
						"url": "//{{baseUrl}}/Report/Pdf"
					},
					"reportSettings": {
						"xrayReport": {
							"type": "xrayReport"
						}
					}
				},
				"type": "ecReportBuilder"
			},
			"standardUKPC": {
				"components": {
					"containerReportBuilder": {
						"settings": {
							"breakpoints": {
								"large": "medium",
								"medium": "small",
								"small": {
									"groups": {
										"all": {
											"cols": 12,
											"defaultSection": {
												"cols": 2
											},
											"order": 0,
											"sections": [
												{
													"cols": 8,
													"sectionId": "reportName"
												},
												"reportGenerateButton",
												"reportCancelButton"
											]
										},
										"coverPage": {
											"cols": 12,
											"defaultSection": {
												"cols": 12
											},
											"order": 2,
											"sections": [
												"reportCoverPageTitle",
												"reportCoverPagePreparedFor",
												"reportCoverPagePreparedBy"
											],
											"show": "{{_ model(_).selectedContents.coverPage _}}"
										},
										"reportPages": {
											"cols": 12,
											"defaultSection": {
												"cols": 12
											},
											"order": 1,
											"sections": [
												"reportContents"
											]
										}
									}
								},
								"xlarge": "large"
							}
						},
						"type": "ecContainer"
					},
					"reportContents": {
						"settings": {
							"_model": {
								"listItems": [
									{
										"key": "coverPage",
										"value": "coverPage"
									},
									{
										"key": "portfolioComparisonReport",
										"value": "portfolioComparison"
									}
								]
							},
							"controlType": "checkbox"
						},
						"type": "ecChosen"
					}
				},
				"settings": {
					"__env": {
						"dev": {
							"pdfServer": "qa"
						},
						"production": {
							"pdfServer": "live"
						},
						"qa": {
							"pdfServer": "qa"
						},
						"stage": {
							"pdfServer": "qa"
						},
						"uat": {
							"pdfServer": "qa"
						}
					},
					"coverPagePreparedByFieldDefinition": [
						{
							"inputType": "text",
							"labelKey": "title"
						},
						{
							"inputType": "text",
							"labelKey": "company"
						},
						{
							"inputType": "text",
							"labelKey": "name"
						},
						{
							"inputType": "text",
							"labelKey": "phone"
						},
						{
							"inputType": "email",
							"labelKey": "email"
						},
						{
							"inputType": "url",
							"labelKey": "website"
						}
					],
					"coverPagePreparedForFieldDefinition": [
						{
							"inputType": "text",
							"labelKey": "clientName"
						},
						{
							"inputType": "text",
							"labelKey": "clientPhone"
						},
						{
							"inputType": "text",
							"labelKey": "clientAddress"
						},
						{
							"inputType": "email",
							"labelKey": "clientEmail"
						}
					],
					"reportDataSource": {
						"requestMethod": "post",
						"type": "UKAPI",
						"url": "//{{baseUrl}}/Report/Pdf"
					},
					"reportSettings": {
						"portfolioComparisonReport": {
							"type": "portfolioPlannerReport"
						}
					}
				},
				"type": "ecReportBuilder"
			},
			"standardUS": {
				"components": {
					"containerReportBuilder": {
						"settings": {
							"breakpoints": {
								"large": "medium",
								"medium": "small",
								"small": {
									"groups": {
										"all": {
											"cols": 12,
											"defaultSection": {
												"cols": 2
											},
											"order": 0,
											"sections": [
												{
													"cols": 8,
													"sectionId": "reportName"
												},
												"reportGenerateButton",
												"reportCancelButton"
											]
										},
										"coverPage": {
											"cols": 12,
											"defaultSection": {
												"cols": 12
											},
											"order": 2,
											"sections": [
												"reportCoverPageTitle",
												"reportCoverPagePreparedFor",
												"reportCoverPagePreparedBy"
											],
											"show": "{{_ model(_).selectedContents.coverPage _}}"
										},
										"reportPages": {
											"cols": 12,
											"defaultSection": {
												"cols": 12
											},
											"order": 1,
											"sections": [
												"reportContents"
											]
										}
									}
								},
								"xlarge": "large"
							}
						},
						"type": "ecContainer"
					},
					"reportContents": {
						"settings": {
							"_model": {
								"listItems": [
									{
										"key": "coverPage",
										"value": "coverPage"
									},
									{
										"key": "portfolioXRay",
										"rearrangeEnabled": true,
										"value": "portfolioXRay"
									},
									{
										"key": "portfolioSnapshot",
										"rearrangeEnabled": true,
										"value": "portfolioSnapshot"
									},
									{
										"key": "historicalPerformance",
										"rearrangeEnabled": true,
										"value": "historicalPerformance"
									},
									{
										"key": "stockIntersection",
										"rearrangeEnabled": true,
										"value": "stockIntersection"
									},
									{
										"key": "correlationMatrix",
										"rearrangeEnabled": true,
										"value": "correlationMatrix"
									},
									{
										"key": "rollingReturns",
										"rearrangeEnabled": true,
										"value": "rollingReturns"
									},
									{
										"key": "priceAndDistribution",
										"rearrangeEnabled": true,
										"value": "priceAndDistribution"
									},
									{
										"key": "investmentDetail",
										"rearrangeEnabled": true,
										"value": "investmentDetail"
									},
									{
										"key": "individualInvestmentFee",
										"rearrangeEnabled": true,
										"value": "individualInvestmentFee"
									},
									{
										"key": "portfolioFeeReport",
										"rearrangeEnabled": true,
										"value": "portfolioFeeReport"
									},
									{
										"key": "disclosure",
										"value": "disclosure"
									}
								]
							},
							"controlType": "checkbox"
						},
						"type": "ecChosen"
					}
				},
				"settings": {
					"coverPagePreparedByFieldDefinition": [
						{
							"inputType": "text",
							"labelKey": "title"
						},
						{
							"inputType": "text",
							"labelKey": "company"
						},
						{
							"inputType": "text",
							"labelKey": "name"
						},
						{
							"inputType": "text",
							"labelKey": "phone"
						},
						{
							"inputType": "email",
							"labelKey": "email"
						},
						{
							"inputType": "url",
							"labelKey": "website"
						}
					],
					"coverPagePreparedForFieldDefinition": [
						{
							"inputType": "text",
							"labelKey": "clientName"
						},
						{
							"inputType": "text",
							"labelKey": "clientPhone"
						},
						{
							"inputType": "text",
							"labelKey": "clientAddress"
						},
						{
							"inputType": "email",
							"labelKey": "clientEmail"
						}
					],
					"reportDataSource": {
						"requestMethod": "post",
						"type": "USAPI",
						"url": "https://{{baseUrl}}/portfolioanalysis/v1/report?langcult={{langcult}}"
					},
					"reportSettings": {
						"RequestSettings": {
							"AnalysisDateTimePeriod": "MonthEnd",
							"AssetClassGroupConfigs": {
								"AssetClassGroupConfig": [
									{
										"Id": "ACG-USDETAILED-15"
									},
									{
										"Id": "ACG-USBROAD"
									}
								]
							},
							"HypoCalculationSettings": {
								"ApplyFeeForRebalance": false,
								"ApplySalesCharge": true,
								"AssetBasedAnnualFee": 0,
								"AssetFeeFrequency": "Annually",
								"AssetFeeType": "Percentage",
								"CapitalGainTaxRate": 0,
								"CustomFeeType": "Amount",
								"DividendTaxRate": 0,
								"EntryExitFeeType": "CustomEntry",
								"FederalIncomeTaxRate": 0,
								"FilingStatus": "NoTaxes",
								"FrontLoadType": "Standard",
								"HypoType": "Portfolio",
								"IllustrationTrailingTimePeriod": "EarliestCommon",
								"InvestmentDetailReturnsFrequency": "Monthly",
								"LiquidateOnEndDate": false,
								"PayFees": "SalesOfSharesEnding",
								"PayFeesUseCashFirst": true,
								"PayTaxes": "OutOfPocket",
								"RebalanceFrequency": "None",
								"RebalanceThreshold": 0,
								"ReinvestCapitalGains": true,
								"ReinvestDividends": true,
								"SalesFeeAmount": 0,
								"StateIncomeTaxRate": 0,
								"SubsequentInvestmentAmount": 0,
								"SubsequentInvestmentType": "Invest",
								"SubsequentInvestmentWithdrawalFrequency": "Monthly",
								"SynchronizePortfolioStartDate": true,
								"TaxableIncome": 50000
							},
							"HypoReportType": "Portfolio",
							"IncludePortfolioInCorrelationMatrix": true,
							"OutputCurrency": "USD",
							"OutputReturnsFrequency": "Annually",
							"ReportSettings": {
								"IncludeDisclosure": true,
								"InvestmentPolicyAgreement": {
									"Name1": "Name1",
									"Name2": "Name2"
								},
								"ReportOrientation": "Portrait"
							},
							"RollingReturnFrequency": "Month3"
						}
					}
				},
				"type": "ecReportBuilder"
			},
			"standardUSHypo": {
				"components": {
					"containerReportBuilder": {
						"settings": {
							"breakpoints": {
								"large": "medium",
								"medium": "small",
								"small": {
									"groups": {
										"all": {
											"cols": 12,
											"defaultSection": {
												"cols": 12
											},
											"order": 0,
											"sections": [
												"reportGenerateButton"
											]
										}
									}
								},
								"xlarge": "large"
							}
						},
						"type": "ecContainer"
					},
					"reportGenerateButton": {
						"labels": {
							"caption": {
								"en": "PDF Report",
								"it": "Report PDF",
								"sv": "PDF-rapport"
							}
						},
						"settings": {
							"buttonCSS": "ec-button__btn--generate"
						},
						"type": "ecButton"
					}
				},
				"settings": {
					"reportDataSource": {
						"requestMethod": "post",
						"type": "USAPI",
						"url": "https://{{baseUrl}}/portfolioanalysis/v1?langcult={{langcult}}"
					},
					"reportSettings": {
						"RequestSettings": {
							"AnalysisDateTimePeriod": "MonthEnd",
							"AssetClassGroupConfigs": {
								"AssetClassGroupConfig": [
									{
										"Id": "ACG-USDETAILED-15"
									},
									{
										"Id": "ACG-USBROAD"
									}
								]
							},
							"HypoReportType": "Portfolio",
							"IncludePortfolioInCorrelationMatrix": true,
							"OutputCurrency": "USD",
							"OutputReturnsFrequency": "Annually",
							"ReportSettings": {
								"IncludeDisclosure": true,
								"InvestmentPolicyAgreement": {
									"Name1": "Name1",
									"Name2": "Name2"
								},
								"ReportOrientation": "Portrait"
							},
							"RollingReturnFrequency": "Month3"
						}
					}
				},
				"type": "ecReportBuilder"
			}
		},
		"components": {
			"containerReportBuilder": {
				"settings": {
					"breakpoints": {
						"large": "medium",
						"medium": "small",
						"small": {
							"groups": {
								"all": {
									"cols": 12,
									"defaultSection": {
										"cols": 6
									},
									"sections": [
										"reportName",
										"reportContents"
									]
								}
							}
						},
						"xlarge": "large"
					},
					"sections": {
						"reportContents": {
							"breakpoints": {
								"large": "small",
								"medium": "small",
								"small": {
									"cols": 6
								},
								"xlarge": "small"
							}
						},
						"reportCoverPagePreparedBy": {
							"breakpoints": {
								"large": "small",
								"medium": "small",
								"small": {
									"cols": 6
								},
								"xlarge": "small"
							}
						},
						"reportCoverPagePreparedFor": {
							"breakpoints": {
								"large": "small",
								"medium": "small",
								"small": {
									"cols": 6
								},
								"xlarge": "small"
							}
						},
						"reportCoverPageTitle": {
							"breakpoints": {
								"large": "small",
								"medium": "small",
								"small": {
									"cols": 12
								},
								"xlarge": "small"
							}
						},
						"reportGenerateButton": {
							"breakpoints": {
								"large": "small",
								"medium": "small",
								"small": {
									"cols": 3
								},
								"xlarge": "small"
							}
						},
						"reportName": {
							"breakpoints": {
								"large": "small",
								"medium": "small",
								"small": {
									"cols": 6
								},
								"xlarge": "small"
							}
						}
					}
				},
				"type": "ecContainer"
			},
			"reportAllContents": {
				"labels": {
					"checkboxText": {
						"da-DK": "Vælg alle",
						"en": "Select all",
						"fr": "Tout sélectionner",
						"it": "Seleziona tutto",
						"sv": "Välj alla",
						"zh-CN": "全选",
						"zh-HK": "全選"
					}
				},
				"settings": {
					"inputType": "checkbox"
				},
				"type": "ecInput"
			},
			"reportCancelButton": {
				"labels": {
					"caption": {
						"da-DK": "Fortryd",
						"en": "Cancel",
						"fr": "Annuler",
						"it": "Cancella",
						"sv": "Ångra",
						"zh-CN": "取消",
						"zh-HK": "取消"
					}
				},
				"type": "ecButton"
			},
			"reportContents": {
				"labels": {
					"advisorNotes": {
						"da-DK": "Rådgivers Noter",
						"en": "Advisor Notes",
						"fr": "Notes du conseiller",
						"it": "Note del consulente",
						"sv": "Rågivarens anteckningar",
						"zh-CN": "顾问笔记",
						"zh-HK": "顧問筆記"
					},
					"clientDetails": {
						"da-DK": "Kundens Detaljer",
						"en": "Client Details",
						"fr": "Détails du client",
						"fr-CA": "Renseignements détaillés sur le client",
						"it": "Dettagli del cliente",
						"sv": "Kundinformation",
						"zh-CN": "客户详情",
						"zh-HK": "客戶詳情"
					},
					"clientGoal": {
						"da-DK": "Kundens Mål",
						"en": "Client Goal",
						"fr": "Objectif du client",
						"it": "Obiettivo del cliente",
						"sv": "Kundens mål",
						"zh-CN": "客户目标",
						"zh-HK": "客戶目標"
					},
					"currentPortfolioVSSelectedInvestment": {
						"da-DK": "Nuværende Portefølje v Valgte Investeringsløsning",
						"en": "Current Portfolio v Selected Investment Solution",
						"fr": "Portefeuille actuel v Solution d'investissement sélectionnée",
						"fr-CA": "Portefeuille actuel / Solution de placement sélectionnée",
						"it": "Portafoglio corrente vs. Soluzione investimento selezionata",
						"sv": "Nuvarande portfölj jämfört med Vald investeringslösning",
						"zh-CN": "目前投资组合v选择的投资解决方案",
						"zh-HK": "目前投資組合 v 選擇的投資解決方案"
					},
					"currentVSRiskProfileVSProposed": {
						"da-DK": "Nuværende v Risikoprofil v Anbefalede",
						"en": "Current v Risk Profile v Proposed",
						"fr": "Actuel v Profil de risque v Proposé",
						"fr-CA": "Actuel / Profil de risque / proposé",
						"it": "Profilo di rischio corrente vs Proposto",
						"sv": "Nuvarande jfr Riskprofil jfr Föreslag",
						"zh-CN": "目前v风险剖析v建议",
						"zh-HK": "目前 v 風險剖析 v 建議"
					},
					"keyInvestorInformationDocuments": {
						"da-DK": "CI",
						"en": "KIID",
						"fr": "DICI",
						"it": "KIID",
						"sv": "KIID",
						"zh-CN": "KIID",
						"zh-HK": "KIID"
					},
					"riskProfile": {
						"da-DK": "Risikoprofil",
						"en": "Risk Profile",
						"fr": "Profil de Risque",
						"fr-CA": "Profil de risque",
						"it": "Profilo di rischio",
						"sv": "Riskprofil",
						"zh-CN": "风险剖析",
						"zh-HK": "風險剖析"
					},
					"selectedInvestmentSolution": {
						"da-DK": "Vælg Investeringsløsning",
						"en": "Selected Investment Solution",
						"fr": "Solution d'investissement sélectionnée",
						"fr-CA": "Solution de placement sélectionnée",
						"it": "Soluzione investimento selezionata",
						"sv": "Välj investeringslösning",
						"zh-CN": "选择的投资解决方案",
						"zh-HK": "選擇的投資解決方案"
					},
					"signOff": {
						"en": "Sign Off",
						"it": "Esci",
						"sv": "Godkänn",
						"zh-CN": "签字",
						"zh-HK": "簽字"
					}
				},
				"settings": {
					"_model": {
						"listItems": [
							{
								"key": "clientDetails",
								"value": "clientDetails"
							},
							{
								"key": "riskProfile",
								"value": "riskProfile"
							},
							{
								"key": "clientGoal",
								"value": "clientGoal"
							},
							{
								"key": "currentVSRiskProfileVSProposed",
								"value": "currentVSRiskProfileVSProposed"
							},
							{
								"key": "selectedInvestmentSolution",
								"value": "selectedInvestmentSolution"
							},
							{
								"key": "currentPortfolioVSSelectedInvestment",
								"value": "currentPortfolioVSSelectedInvestment"
							},
							{
								"key": "advisorNotes",
								"value": "advisorNotes"
							},
							{
								"key": "keyInvestorInformationDocuments",
								"value": "keyInvestorInformationDocuments"
							},
							{
								"key": "signOff",
								"value": "signOff"
							}
						]
					},
					"controlType": "checkbox"
				},
				"type": "ecChosen"
			},
			"reportCoverPageTitle": {
				"settings": {
					"inputType": "text"
				},
				"type": "ecInput"
			},
			"reportGenerateButton": {
				"labels": {
					"caption": {
						"da-DK": "Generér",
						"en": "Generate",
						"fr": "Générer",
						"it": "Genera",
						"sv": "Generera",
						"zh-CN": "产生",
						"zh-HK": "產生"
					}
				},
				"settings": {
					"disabled": true
				},
				"type": "ecButton"
			},
			"reportName": {
				"type": "ecInput"
			},
			"reportNotesFieldText": {
				"settings": {
					"cols": 100,
					"inputType": "textarea",
					"rows": 10
				},
				"type": "ecInput"
			},
			"reportPortfolioName": {
				"settings": {
					"inputType": "text"
				},
				"type": "ecInput"
			},
			"reportPreparedFieldEmail": {
				"settings": {
					"inputType": "email"
				},
				"type": "ecInput"
			},
			"reportPreparedFieldNumber": {
				"settings": {
					"inputType": "number"
				},
				"type": "ecInput"
			},
			"reportPreparedFieldText": {
				"settings": {
					"inputType": "text"
				},
				"type": "ecInput"
			},
			"reportPreparedFieldUrl": {
				"settings": {
					"inputType": "url"
				},
				"type": "ecInput"
			}
		},
		"labels": {
			"address": {
				"da-DK": "Adresse",
				"en": "Address",
				"en-GB": null,
				"fr": "Adresse",
				"it": "Indirizzo",
				"sv": "Adress",
				"sv-SE": null,
				"zh-CN": "地址",
				"zh-HK": "地址"
			},
			"city": {
				"da-DK": "By",
				"en": "City",
				"en-GB": null,
				"fr": "Ville",
				"it": "Città",
				"sv": "Stad",
				"sv-SE": null,
				"zh-CN": "城市",
				"zh-HK": "城市"
			},
			"clientAddress": {
				"da-DK": "Kundens Adresselinje",
				"en": "Client Address Line",
				"en-GB": null,
				"fr": "Adresse du client",
				"fr-CA": "Ligne adresse du client",
				"it": "Indirizzo cliente riga",
				"sv": "Kundens adress",
				"sv-SE": null,
				"zh-CN": "客户地址",
				"zh-HK": "客戶地址"
			},
			"clientEmail": {
				"da-DK": "Kundens E-mail Adresse",
				"en": "Client Email Address",
				"en-GB": null,
				"fr": "Email du client",
				"fr-CA": "Adresse courriel du client",
				"it": "Indirizzo e-mail cliente",
				"sv": "Kundens epost",
				"sv-SE": null,
				"zh-CN": "客户电邮地址",
				"zh-HK": "客戶電郵地址"
			},
			"clientName": {
				"da-DK": "Kundens Navn",
				"en": "Client Name",
				"en-GB": null,
				"fr": "Nom du client",
				"it": "Nome cliente",
				"sv": "Kundens namn",
				"sv-SE": null,
				"zh-CN": "客户名称",
				"zh-HK": "客戶名稱"
			},
			"clientPhone": {
				"da-DK": "Kundens Telefonnummer",
				"en": "Client Phone Number",
				"en-GB": null,
				"fr": "Téléphone du client",
				"fr-CA": "Numéro de téléphone du client",
				"it": "Numero di telefono cliente",
				"sv": "Kundens telefonnummer",
				"sv-SE": null,
				"zh-CN": "客户电话号码",
				"zh-HK": "客戶電話號碼"
			},
			"company": {
				"da-DK": "Selskabs Navn",
				"en": "Company Name",
				"en-GB": null,
				"fr": "Nom de la société",
				"fr-CA": "Nom de la compagnie",
				"it": "Nome società",
				"sv": "Företagsnamn",
				"sv-SE": null,
				"zh-CN": "公司名称",
				"zh-HK": "公司名稱"
			},
			"correlationMatrix": {
				"da-DK": "Korrelationsmatrice",
				"en": "Correlation Matrix",
				"en-GB": null,
				"fr": "Matrice de corrélation",
				"it": "Matrice correlazione",
				"sv": "Korrelationsmatris",
				"sv-SE": null,
				"zh-CN": "相关性矩阵",
				"zh-HK": "相關性矩陣"
			},
			"costAnalysis": {
				"en": null,
				"en-GB": null,
				"sv-SE": null
			},
			"coverPage": {
				"da-DK": "Forside",
				"en": "Cover Page",
				"en-GB": null,
				"fr": "Page de garde",
				"fr-CA": "Page de couverture",
				"it": "Copertina",
				"sv": "Framsida",
				"sv-SE": null,
				"zh-CN": "封面",
				"zh-HK": "封面"
			},
			"disclosure": {
				"da-DK": "Offentliggørelse",
				"en": "Disclosure",
				"en-GB": null,
				"it": "Informativa",
				"sv": "Disclosure",
				"sv-SE": null
			},
			"email": {
				"da-DK": "E-mail Adresse",
				"en": "Email Address",
				"en-GB": null,
				"fr": "E-Mail",
				"fr-CA": "Adresse courriel",
				"it": "Indirizzo e-mail",
				"sv": "Epostadress",
				"sv-SE": null,
				"zh-CN": "电邮地址",
				"zh-HK": "電郵地址"
			},
			"historicalPerformance": {
				"da-DK": "Historisk Afkast",
				"en": "Historical Performance",
				"en-GB": null,
				"fr": "Performance historique",
				"it": "Performance storica",
				"sv": "Historisk utveckling",
				"sv-SE": null,
				"zh-CN": "历史表现",
				"zh-HK": "歷史表現"
			},
			"individualInvestmentFee": {
				"da-DK": "Individuel Investeringsomkostning",
				"en": "Individual Investment Fee",
				"en-GB": null,
				"it": "Commissione d'investimento individuale",
				"sv": "Individuell investeringsavgift",
				"sv-SE": null
			},
			"investmentDetail": {
				"da-DK": "Investeringsdetaljer",
				"en": "Investment Detail",
				"en-GB": null,
				"fr": "Détails de l'investissement",
				"fr-CA": "Renseignements sur les placements",
				"it": "Dettaglio dell'investimento",
				"sv": "Investeringsdetaljer",
				"sv-SE": null,
				"zh-CN": "投资详情",
				"zh-HK": "投資詳情"
			},
			"investmentPolicyAgreement": {
				"da-DK": "Aftale om Investeringspolitik",
				"en": "Investment Policy Agreement",
				"en-GB": null,
				"fr": "Accord sur la politique d'investissement",
				"fr-CA": "Accord sur la politique de placement",
				"it": "Accordo relativo alla politica d'investimento",
				"sv": "Investeringsavtal",
				"sv-SE": null,
				"zh-CN": "投资政策协议",
				"zh-HK": "投資政策協議"
			},
			"name": {
				"da-DK": "Navn",
				"en": "Name",
				"en-GB": null,
				"fr": "Nom",
				"it": "Nome",
				"sv": "Namn",
				"sv-SE": null,
				"zh-CN": "名称",
				"zh-HK": "名稱"
			},
			"notes": {
				"da-DK": "Noter",
				"en": "Notes",
				"fr": "Remarques",
				"it": "Note",
				"sv": "Anteckningar",
				"zh-CN": "备注",
				"zh-HK": "備註"
			},
			"phone": {
				"da-DK": "Telefonnummer ",
				"en": "Phone Number",
				"en-GB": null,
				"fr": "Téléphone",
				"it": "Numero di telefono",
				"sv": "Telefonnummer",
				"sv-SE": null,
				"zh-CN": "电话号码",
				"zh-HK": "電話號碼"
			},
			"portfolioComparison": {
				"en": "Portfolio Comparison",
				"en-GB": null,
				"it": "Confronto portafoglio",
				"sv": "Portföljjämförelse",
				"sv-SE": null
			},
			"portfolioComparisonFee": {
				"en": "Portfolio Comparison Fee",
				"en-GB": null,
				"it": "Confronto commissioni",
				"sv": "Portföljjämförelseavgift",
				"sv-SE": null
			},
			"portfolioFeeReport": {
				"da-DK": "Oversigt Over Porteføljeomkostninger",
				"en": "Portfolio Fee Report",
				"en-GB": null,
				"it": "Report commissioni di portafoglio",
				"sv": "Portföljavgiftsrapport",
				"sv-SE": null
			},
			"portfolioName": {
				"en": "Portfolio Name",
				"it": "Nome del portafoglio",
				"sv": "Portföljnamn"
			},
			"portfolioSnapshot": {
				"da-DK": "Portefølje Snapshot",
				"en": "Portfolio Snapshot",
				"en-GB": null,
				"fr": "Aperçu du portefeuille",
				"it": "Snapshot portafoglio",
				"sv": "Portfolio Snapshot",
				"sv-SE": null,
				"zh-CN": "投资组合摘要",
				"zh-HK": "投資組合摘要"
			},
			"portfolioXRay": {
				"da-DK": "Gennemlysning af Portefølje",
				"en": "Portfolio XRay",
				"en-GB": null,
				"fr": "Xray du portefeuille",
				"fr-CA": "Anatomie du portefeuille",
				"it": "Portafoglio Raggi-X",
				"sv": "Portföljanalys (X-Ray)",
				"sv-SE": null,
				"zh-CN": "投资组合透视",
				"zh-HK": "投資組合透視"
			},
			"priceAndDistribution": {
				"da-DK": "Pris og Distribution",
				"en": "Price And Distribution",
				"en-GB": null,
				"fr": "Prix et distribution",
				"it": "Prezzo e distribuzione",
				"sv": "Kostnader och distribution",
				"sv-SE": null,
				"zh-CN": "价格和派息",
				"zh-HK": "價格和派息"
			},
			"reportContents": {
				"da-DK": "Indhold",
				"en": "Contents",
				"en-GB": null,
				"fr": "Contenu",
				"it": "Indice",
				"sv": "Innehåll",
				"sv-SE": null,
				"zh-CN": "内容",
				"zh-HK": "內容"
			},
			"reportCoverPage": {
				"da-DK": "Forside",
				"en": "Cover Page",
				"en-GB": null,
				"fr": "Page de garde",
				"fr-CA": "Page de couverture",
				"it": "Copertina",
				"sv": "Framsida",
				"sv-SE": null,
				"zh-CN": "封面",
				"zh-HK": "封面"
			},
			"reportCoverPageTitle": {
				"da-DK": "Rapportens Overskrift",
				"en": "Report Title",
				"en-GB": null,
				"fr": "Titre du rapport",
				"it": "Titolo Report",
				"sv": "Titel på rapporten",
				"sv-SE": null,
				"zh-CN": "报告标题",
				"zh-HK": "報告標題"
			},
			"reportName": {
				"da-DK": "Foreslået navn",
				"en": "Proposal name",
				"en-GB": null,
				"fr": "Nom de la proposition",
				"it": "Nome della proposta",
				"sv": "Namn på förslag",
				"sv-SE": null,
				"zh-CN": "建议书名称",
				"zh-HK": "建議書名稱"
			},
			"reportPortfolioName": {
				"en": null,
				"en-GB": null,
				"sv-SE": null
			},
			"reportPreparedBy": {
				"da-DK": "Udarbejdet Af",
				"en": "Prepared By",
				"en-GB": null,
				"fr": "Préparé par",
				"it": "Preparato da",
				"sv": "Framtagen av",
				"sv-SE": null,
				"zh-CN": "由...编制",
				"zh-HK": "由...編制"
			},
			"reportPreparedFor": {
				"da-DK": "Udarbejdet For",
				"en": "Prepared For",
				"en-GB": null,
				"fr": "Préparé pour",
				"it": "Preparato per",
				"sv": "Framtagen för",
				"sv-SE": null,
				"zh-CN": "为...编制",
				"zh-HK": "為...編制"
			},
			"rollingReturns": {
				"da-DK": "Løbende Afkast",
				"en": "Rolling Returns",
				"en-GB": null,
				"fr": "Performances ",
				"fr-CA": "Rendements moyens",
				"it": "Rendimenti rolling",
				"sv": "Rullande avkastning",
				"sv-SE": null,
				"zh-CN": "滚动回报",
				"zh-HK": "滾動回報"
			},
			"stockIntersection": {
				"da-DK": "Aktie Skæringspunkt",
				"en": "Stock Intersection",
				"en-GB": null,
				"fr-CA": "Chevauchement des actions",
				"it": "Intersezione azionaria",
				"sv": "Stock Intersection",
				"sv-SE": null,
				"zh-CN": "股票交接点",
				"zh-HK": "股票交接點"
			},
			"title": {
				"da-DK": "Titel",
				"en": "Title",
				"en-GB": null,
				"fr": "Titre",
				"it": "Titolo",
				"sv": "Titel",
				"sv-SE": null,
				"zh-CN": "标题",
				"zh-HK": "標題"
			},
			"website": {
				"da-DK": "Hjemmeside",
				"en": "Web Address",
				"en-GB": null,
				"fr": "Site Internet",
				"fr-CA": "Addresse site Internet",
				"it": "Indirizzo web",
				"sv": "Webbsida",
				"sv-SE": null,
				"zh-CN": "网址",
				"zh-HK": "網址"
			}
		},
		"settings": {
			"_model": {
				"coverPageUserInput": {
					"calculated": {
						"properties": {
							"show": {
								"data": "{{_ model().selectedContents _}}",
								"transformPipeline": [
									{
										"name": "mapSingle",
										"options": {
											"criteria": {
												"args": [
													{
														"args": {
															"property": "coverPage",
															"value": true
														},
														"fn": "eq"
													},
													{
														"args": {
															"property": "signOff",
															"value": true
														},
														"fn": "eq"
													}
												],
												"fn": "or"
											}
										}
									}
								]
							}
						}
					}
				},
				"reportInfo": {
					"api": {
						"method": "get",
						"parameters": {
							"deep": true,
							"isTransformSync": false,
							"throttleTime": 200,
							"transformPipeline": []
						},
						"url": null,
						"usePreviousDataOnError": true,
						"validationExpression": "",
						"validationExpressions": []
					},
					"dataSourceType": "",
					"defaults": null,
					"merge": false,
					"propagateChanges": {
						"trigger": "auto"
					},
					"selector": null,
					"transformPipeline": []
				},
				"selectedContents": null
			},
			"_parameters": {
				"isLoading": {},
				"urlKey": {}
			},
			"_templates": {
				"main": "<ec-section mstar-loader=\"parameters.isLoading\">\r\n    <ec-container mstar-component-id=\"containerReportBuilder\" class=\"{{::namespaceClass()}}\">\r\n        <ec-section data-ng-repeat=\"(key,value) in templates.custom track by $index\" section-id=\"{{key}}\" title=\"{{labels.get(key)}}\">\r\n            <div mstar-include=\"value\"></div>\r\n        </ec-section>\r\n        <ec-section section-id=\"reportName\" title=\"{{::labels.get('reportName')}}\">\r\n            <label for=\"{{::namespaceId('reportName')}}-textbox\" class=\"{{::namespaceClass('__report-name-label')}}\">{{::labels.get('reportName')}}</label>\r\n            <ec-input mstar-component-id=\"reportName\" data-ng-model=\"model.reportInfo.reportName\" class=\"{{::namespaceClass('__report-name-input')}}\"></ec-input>\r\n        </ec-section>\r\n        <ec-section section-id=\"reportContents\" title=\"{{::labels.get('reportContents')}}\">\r\n            <div class=\"{{::namespaceClass('__report-contents-all')}}\">\r\n                <ec-input mstar-component-id=\"reportAllContents\" data-ng-model=\"allCheckboxesSelected\" data-ng-model-options=\"{getterSetter: true}\" data-ng-click=\"handleSelectAllClick($event)\" data-ng-class=\"partialSelect ? '{{namespaceClass('__input--mixed')}}' : ''\"></ec-input>\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__report-contents')}}\">\r\n                <ec-chosen mstar-component-id=\"reportContents\" data-ng-model=\"model.reportInfo.reportContents\"></ec-chosen>\r\n            </div>\r\n        </ec-section>\r\n        <ec-section section-id=\"reportCoverPageTitle\" title=\"{{::labels.get('reportCoverPage')}}\">\r\n            <div class=\"{{::namespaceClass('__cover-page-title-wrapper')}}\">\r\n                <label class=\"{{::namespaceClass('__cover-page-title')}}\">{{::labels.get('reportCoverPageTitle')}}</label>\r\n                <ec-input mstar-component-id=\"reportCoverPageTitle \" data-ng-model=\"model.reportInfo.reportCoverPage.title \" class=\"{{::namespaceClass( '__cover-page-title-input')}}\"></ec-input>\r\n            </div>\r\n            <div class=\"{{::namespaceClass('__cover-page-portfolio-name')}}\">\r\n                <label class=\"{{::namespaceClass('__cover-page-label-client-name')}}\">{{::labels.get('portfolioName')}}</label>\r\n                <ec-input mstar-component-id=\"reportPortfolioName\" data-ng-model=\"model.reportInfo.reportPortfolios[0].reportName\" class=\"{{::namespaceClass('__cover-page-title-input')}}\"></ec-input>\r\n            </div>\r\n        </ec-section>\r\n        <ec-section section-id=\"reportCoverPagePreparedFor\" title=\"{{::labels.get('reportPreparedFor')}}\">\r\n            <div data-ng-repeat=\"obj in coverPagePreparedFor track by $index \" class=\"{{::namespaceClass('__cover-page-prepared-for')}}\">\r\n                <label class=\"{{::namespaceClass('__cover-page-label')}} {{::namespaceClass('__cover-page-label-'+obj.className)}}\">{{::labels.get(obj.labelKey)}}</label>\r\n                <ec-input mstar-component-id=\"reportPreparedField{{obj.inputType}}[{{$index}}]\" data-ng-model=\"model.reportInfo.reportCoverPage.preparedFor[obj.labelKey]\" class=\"{{::namespaceClass('__cover-page-prepared-for-input')}} {{::namespaceClass('__cover-page-prepared-for-input-' + obj.className)}}\"></ec-input>\r\n            </div>\r\n        </ec-section>\r\n        <ec-section section-id=\"reportCoverPagePreparedBy\" title=\"{{::labels.get('reportPreparedBy')}}\">\r\n            <div data-ng-repeat=\"obj in coverPagePreparedBy track by $index\" class=\"{{::namespaceClass('__cover-page-prepared-by')}}\">\r\n                <label class=\"{{::namespaceClass('__cover-page-label')}} {{::namespaceClass('__cover-page-label-'+obj.className)}}\">{{::labels.get(obj.labelKey)}}</label>\r\n                <ec-input mstar-component-id=\"reportPreparedField{{obj.inputType}}[{{$index}}]\" data-ng-model=\"model.reportInfo.reportCoverPage.preparedBy[obj.labelKey]\" class=\"{{::namespaceClass('__cover-page-prepared-by-input')}} {{::namespaceClass('__cover-page-prepared-by-input-' + obj.className)}}\"></ec-input>\r\n            </div>\r\n        </ec-section>\r\n        <ec-section section-id=\"reportNotes\" title=\"{{::labels.get('advisorNotes')}}\">\r\n            <div data-ng-repeat=\"obj in notes track by $index\" class=\"{{::namespaceClass('__notes')}}\">\r\n                <label class=\"{{::namespaceClass('__notes-label')}} {{::namespaceClass('__notes-label-'+obj.className)}}\">{{::labels.get(obj.labelKey)}}</label>\r\n                <ec-input mstar-component-id=\"reportNotesField{{obj.inputType}}[{{$index}}]\" data-ng-model=\"model.reportInfo.reportNotesPage.notes[obj.labelKey]\" class=\"{{::namespaceClass('__notes-input')}} {{::namespaceClass('__notes-input-' + obj.className)}}\"></ec-input>\r\n            </div>\r\n        </ec-section>\r\n        <ec-section template-type=\"light\" section-id=\"reportGenerateButton\">\r\n            <ec-button mstar-component-id=\"reportGenerateButton\" class=\"{{parameters.isLoading ? namespaceClass('__report-generate-button--loading') : ''}}\"></ec-button>\r\n        </ec-section>\r\n        <ec-section template-type=\"light\" section-id=\"reportCancelButton\">\r\n            <ec-button mstar-component-id=\"reportCancelButton\"></ec-button>\r\n        </ec-section>\r\n    </ec-container>\r\n</ec-section>"
			},
			"coverPageDateFormat": null,
			"coverPagePreparedByFieldDefinition": null,
			"coverPagePreparedForFieldDefinition": null,
			"namespaceClass": "ec-report-builder",
			"notesFieldDefinition": null,
			"pdfServer": null,
			"reportDataSource": {
				"requestMethod": null,
				"type": null,
				"url": null
			},
			"reportSettings": null,
			"urlKey": null
		},
		"type": "ecReportBuilder"
	}
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar) {
    'use strict';

    morningstar.asterix.ng.register('ecReportBuilder', __webpack_require__(6).ecReportBuilder);

    __webpack_require__(3);
    __webpack_require__(5);
    __webpack_require__(4);
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = {
	"xray": {
		"uk": {
			"coverPagePreparedForFieldDefinition": {
				"clientName": "preparedForName",
				"clientPhone": "preparedForPhone",
				"clientAddress": "preparedForAddressLine1",
				"clientEmail": "preparedForEmail"
			},
			"coverPagePreparedByFieldDefinition": {
				"name": "preparedByAdvisorName1",
				"phone": "preparedByPhone",
				"title": "preparedByAdvisorTitle1",
				"email": "preparedByAdvisorEmail1",
				"company": "preparedByFirmName",
				"website": "preparedByWebsite"
			}
		},
		"us": {
			"coverPagePreparedForFieldDefinition": {
				"clientName": "Name",
				"clientPhone": "Phone",
				"clientAddress": "Address",
				"clientEmail": "Email"
			},
			"coverPagePreparedByFieldDefinition": {
				"advisors": {
					"name": "Name",
					"title": "Title",
					"email": "Email"
				},
				"phone": "Phone",
				"company": "FirmName",
				"website": "Website"
			}
		}
	}
};

/***/ })
/******/ ]);
//# sourceMappingURL=ec-report-builder.js.map


// WEBPACK FOOTER //
// ./components/report-builder/build/ec-report-builder.js